export default "__VITE_ASSET__BP7Ev3BW__"